import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import {
  NavLink as RouterLink,
  matchPath,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import arrowIosForwardFill from "@iconify/icons-eva/arrow-ios-forward-fill";
import arrowIosDownwardFill from "@iconify/icons-eva/arrow-ios-downward-fill";
// material
import { alpha, useTheme, styled } from "@mui/material/styles";
import InboxIcon from "@mui/icons-material/MoveToInbox";
// drop
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import DateRangeIcon from "@mui/icons-material/DateRange";
import SettingsIcon from "@mui/icons-material/Settings";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
// drop
import {
  Box,
  List,
  Collapse,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  TextField,
} from "@mui/material";
import { get_root_value } from "src/utils/domUtils";
import { fontSize } from "@mui/system";
import { set } from "lodash";
import { useContentSetting } from "src/Hooks/ContentSettingState";

// ----------------------------------------------------------------------

const ListItemStyle = styled((props) => (
  <ListItemButton disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: "relative",
  textTransform: "capitalize",
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(2.5),
  color: get_root_value("--input-text-color"),
  "&:before": {
    top: 0,
    right: 0,
    width: 3,
    bottom: 0,
    content: "''",
    display: "none",
    position: "absolute",
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    backgroundColor: theme.palette.primary.main,
  },
}));

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.func,
};

function NavItem({ item, active, openDra }) {
  const theme = useTheme();
  const isActiveRoot = active(item.path);
  const { title, path, icon, info, children } = item;
  const [open, setOpen] = useState(isActiveRoot);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const activeRootStyle = {
    color: theme.palette.primary.main,
    fontWeight: "fontWeightMedium",
    bgcolor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity,
    ),
    "&:before": { display: "block" },
  };

  const activeSubStyle = {
    color: get_root_value("--portal-theme-primary"),
    fontWeight: "fontWeightMedium",
    bgcolor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity,
    ),
  };
  useEffect(() => {
    setOpen(openDra);
  }, [openDra]);
  useEffect(() => {
    // On reload dropdown should not close
    if (item?.children)
      item?.children.map((child_option) => {
        if (window.location.pathname.includes(child_option?.path)) {
          setOpen(true);
        }
      });
  }, [window.location.pathname, !openDra]);
  if (children) {
    return (
      <>
        <ListItemStyle
          onClick={handleOpen}
          sx={{
            ...(isActiveRoot && activeRootStyle),
          }}
        >
          <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
          <ListItemText disableTypography primary={title} />
          {info && info}
          <Box
            component={Icon}
            icon={open ? arrowIosDownwardFill : arrowIosForwardFill}
            sx={{ width: 16, height: 16, ml: 1 }}
          />
        </ListItemStyle>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((item) => {
              const { title, path, icon } = item;
              const isActiveSub = active(path);
              return (
                <ListItemStyle
                  key={title}
                  component={RouterLink}
                  to={path}
                  sx={{
                    ...(isActiveSub && activeSubStyle),

                    pl: 8,
                    // color: "white",
                    fontSize: "14px",
                  }}
                >
                  <ListItemIconStyle>{icon}</ListItemIconStyle>
                  <ListItemText disableTypography primary={title} />
                </ListItemStyle>
              );
            })}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <ListItemStyle
      component={RouterLink}
      to={path}
      sx={{
        ...(isActiveRoot && activeRootStyle),
      }}
    >
      <ListItemIconStyle
        sx={{
          ...(isActiveRoot && activeRootStyle),
        }}
      >
        {icon && icon}
      </ListItemIconStyle>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </ListItemStyle>
  );
}

NavSection.propTypes = {
  navConfig: PropTypes.array,
};

export default function NavSection({ navConfig, ...other }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { programTab } = useContentSetting();
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openSession, setOpenSession] = useState(false);
  const [openExtras, setOpenExtras] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [openSupport, setOpenSupport] = useState(false);
  const [openClient, setOpenClient] = useState(false);
  const [openConsultant, setOpenConsultant] = useState(false);
  const [openSetting, setOpenSetting] = useState(false);
  const [openWebsiteSetting, setOpenWebsiteSetting] = useState(false);
  const [openHelpingVideos, setOpenHelpingVideos] = useState(false);
  const [openCommunity, setOpenCommunity] = useState(false);

  const handleClick = () => {
    setOpenDropdown(!openDropdown);
  };
  const handleClickSession = () => {
    setOpenSession(!openSession);
  };
  const handleClickExtras = () => {
    setOpenExtras(!openExtras);
  };
  const handleClickPayment = () => {
    setOpenPayment(!openPayment);
  };
  const handleClickCalendar = () => {
    setOpenCalendar(!openCalendar);
  };
  const handleClickSupport = () => {
    setOpenSupport(!openSupport);
  };
  const handleClickClient = () => {
    setOpenClient(!openClient);
  };
  const handleClickConsultant = () => {
    setOpenConsultant(!openConsultant);
  };
  const handleClickSetting = () => {
    setOpenSetting(!openSetting);
  };
  const handleClickWebsiteSetting = () => {
    setOpenWebsiteSetting(!openWebsiteSetting);
  };
  const handleClickHelpingVideos = () => {
    setOpenHelpingVideos(!openHelpingVideos);
  };

  const handleNavigateRecordings = () => {
    navigate("/recording-list");
  };
  const handleNavigateCategory = () => {
    navigate("/categories");
  };
  const handleNavigateSessions = () => {
    navigate("/sessions");
  };
  const handleNavigateSessionsRecording = () => {
    navigate("/session-recording");
  };
  const handleNavigateQuotes = () => {
    navigate("/quotesList");
  };
  const handleNavigateGratitude = () => {
    navigate("/gratitude");
  };
  const handleNavigateAffirmation = () => {
    navigate("/affirmation");
  };
  const handleNavigateAffirmationCategories = () => {
    navigate("/affirmations-categories");
  };
  const handleNavigateTransaction = () => {
    navigate("/payment-transactions");
  };
  const handleNavigateStripeProducts = () => {
    navigate("/stripe-products");
  };
  const handleNavigatePaymentTemplate = () => {
    navigate("/payment-templates");
  };
  const handleNavigatePaymentRequest = () => {
    navigate("/payment-requests");
  };

  const handleNavigateCalendarPods = () => {
    navigate("/calendar-pods");
  };
  const handleNavigateCalendar = () => {
    navigate("/calendarEvents");
  };
  const handleNavigateDepartment = () => {
    navigate("/departments");
  };
  const handleNavigateSupportTicket = () => {
    navigate("/support-tickets");
  };
  const handleNavigateGeneralSetting = () => {
    navigate("/general-setting");
  };
  const handleNavigateClientDashboard = () => {
    navigate("/client-dashboard");
  };
  const handleNavigateContentSetting = () => {
    navigate("/content-setting");
  };

  const handleNavigateEvents = () => {
    navigate("/website-events");
  };
  const handleNavigateDynamiteEvents = () => {
    navigate("/dynamite-events");
  };

  const handleNavigateDynamiteEventCategoryVideo = () => {
    navigate("/dynamite-event-category-videos");
  };
  const handleNavigateConsultantGeneralSetting = () => {
    navigate("/consultants-general-setting");
  };
  const handleNavigateSendGrid = () => {
    navigate("/send-grid");
  };
  const handleNavigateCompaign = () => {
    navigate("/campaign-setting");
  };
  const handleNavigateInvoice = () => {
    navigate("/invoice-setting");
  };
  const handleNavigateStripe = () => {
    navigate("/stripe-setting");
  };
  const handleNavigateEmailSetting = () => {
    navigate("/email-setting");
  };
  const handleNavigateDefaultSetting = () => {
    navigate("/default-setting");
  };
  const handleNavigateEmailTemplates = () => {
    navigate("/email-templates");
  };
  const handleNavigateWebsitePages = () => {
    navigate("/website-pages");
  };
  const handleNavigateAdminVideos = () => {
    navigate("/admin-videos");
  };
  const handleNavigateClientVideos = () => {
    navigate("/client-portal-videos");
  };
  const handleNavigateWebsiteEvents = () => {
    navigate("/template-pages");
  };
  const handleNavigateWebsiteTestimonial = () => {
    navigate("/menus");
  };
  const handleNavigateWebsitePodCast = () => {
    navigate("/website-podcasts");
  };
  const handleNavigateWebsiteProgrammes = () => {
    navigate("/website-programmes");
  };
  const handleNavigateGeneralPaymentPlan = () => {
    navigate("/website-general-payment-plans");
  };

  const handleNavigateProgrammeCategories = () => {
    navigate("/website-categories");
  };
  const handleNavigateFAQ = () => {
    navigate("/website-faq");
  };
  const handleNavigateTeam = () => {
    navigate("/website-team");
  };
  const handleNavigateMedia = () => {
    navigate("/media-section");
  };
  const handleNavigateSuccessProduct = () => {
    navigate("/success-product");
  };
  const handleNavigatePodcasts = () => {
    navigate("/website-podcasts");
  };

  const matchSideBar = (path) => {
    let program_tab = programTab;
    let check = pathname.includes("/programmes");

    if (path === "/programmes" && check) {
      if (program_tab === "active") return true;
      return false;
    } else if (path === "/inactive-programmes" && check) {
      if (program_tab === "inactive") return true;
      return false;
    } else {
      return path ? !!matchPath({ path, end: false }, pathname) : false;
    }
  };

  const match = ({ path, matches }) => {
    if (matches) {
      let is_active = false;
      matches.forEach((match_path) => {
        const match = match_path
          ? !!matchPath({ path: match_path, end: false }, pathname)
          : false;

        if (match) {
          is_active = true;
        }
      });

      return is_active;
    }
    return path ? !!matchPath({ path, end: false }, pathname) : false;
  };

  // =============good one is that but if thay ask then i show that because it will just mached chid not all childes

  // const findItemsByQuery = (query) => {
  //   const matchingItems = navConfig
  //     .map((item) => {
  //       const matchedChildren = item?.children
  //         ? item?.children.filter((child) =>
  //             child.title.toLowerCase().includes(query.toLowerCase())
  //           )
  //         : "";
  //       if (
  //         item?.title.toLowerCase().includes(query.toLowerCase()) ||
  //         matchedChildren.length > 0
  //       ) {
  //         return {
  //           ...item,
  //           children: matchedChildren,
  //         };
  //       }
  //       return null;
  //     })
  //     .filter(Boolean);

  //   return matchingItems;
  // };
  const findItemsByQuery = (query) => {
    const matchingItems = navConfig
      .map((item) => {
        // Filter children based on query
        const matchedChildren = item?.children
          ? item.children.filter((child) =>
              child.title.toLowerCase().includes(query.toLowerCase()),
            )
          : [];

        // Check if the parent or any child matches the query
        if (
          item.title.toLowerCase().includes(query.toLowerCase()) ||
          matchedChildren.length > 0
        ) {
          return {
            ...item,
            // Return all children if any child matches the query
            children:
              matchedChildren.length > 0 ? matchedChildren : item.children,
          };
        }
        return null;
      })
      .filter(Boolean); // Remove null values

    return matchingItems;
  };

  // =======
  // const findItemsByQuery = (query) => {
  //   const matchingItems = navConfig.filter(
  //     (item) =>
  //       item.title.toLowerCase().includes(query.toLowerCase()) ||
  //       (item.children &&
  //         item.children.some((child) =>
  //           child.title.toLowerCase().includes(query.toLowerCase())
  //         ))
  //   );
  //   return matchingItems;
  // };

  const [query, setQuery] = useState("");
  const matchingItems = findItemsByQuery(query.trim());
  // console.log("Matching items:", matchingItems, navConfig);

  return (
    <Box {...other}>
      <div className="text-center">
        <TextField
          size="small"
          id="outlined-basic"
          label=""
          variant="outlined"
          autoComplete="off"
          sx={{
            width: "85%",

            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            mb: 1,
          }}
          // fullWidth
          required
          name="question_statement"
          placeholder="Search..."
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
        />
      </div>
      <List disablePadding sx={{ mb: 6 }}>
        {matchingItems.map((item) => (
          <NavItem
            key={item.title}
            item={item}
            active={matchSideBar}
            openDra={query ? true : false}
          />
        ))}
      </List>
    </Box>
  );
}
